import { createEnv } from '@t3-oss/env-core';
import { z } from 'zod';

export const env = createEnv({
  clientPrefix: 'NEXT_PUBLIC_', // prefix for client env vars
  client: {
    NEXT_PUBLIC_GOOGLE_MAPS_API_KEY: z.string().min(1),
    NEXT_PUBLIC_API_ROOT_URL: z.string().min(1),
    // mapbox
    NEXT_PUBLIC_MAPBOX_TOKEN: z.string().min(1),
    // sanity
    NEXT_PUBLIC_SANITY_PROJECT_ID: z.string().min(1),
    // supabase
    NEXT_PUBLIC_SUPABASE_URL: z.string().min(1),
    NEXT_PUBLIC_SUPABASE_ANON_KEY: z.string().min(1),
    // klaviyo
    NEXT_PUBLIC_KLAVIYO_PUBLIC_API_KEY: z.string().min(1),
    // posthog
    NEXT_PUBLIC_POSTHOG_KEY: z.string().min(1),
    NEXT_PUBLIC_POSTHOG_HOST: z.string().min(1),
    // algolia
    NEXT_PUBLIC_ALGOLIA_APP_ID: z.string().min(1),
    NEXT_PUBLIC_SEARCH_ALGOLIA_API_KEY: z.string().min(1),
  },
  server: {
    DATABASE_URL: z.string().min(1),
    DIRECT_URL: z.string().min(1),
    // github
    GITHUB_ID: z.string().min(1),
    GITHUB_SECRET: z.string().min(1),
    // google
    GOOGLE_CLIENT_ID: z.string().min(1),
    GOOGLE_CLIENT_SECRET: z.string().min(1),
    // slack
    SLACK_ACCESS_TOKEN: z.string().min(1),
    SLACK_CUSTOMER_CHANNEL_ID: z.string().min(1),
    SLACK_TEAM_VERIFICATION_CHANNEL_ID: z.string().min(1),
    SLACK_AD_CONTACT_CHANNEL_ID: z.string().min(1),
    SLACK_USER_SIGNUP_CHANNEL_ID: z.string().min(1),
    SLACK_MAILING_LIST_CHANNEL_ID: z.string().min(1),
    SLACK_STATS_CHANNEL_ID: z.string().min(1),
    SLACK_SANITY_UPDATES_CHANNEL_ID: z.string().min(1),
    SLACK_USER_TEAM_INTEREST_CHANNEL_ID: z.string().min(1),
    // sanity
    SANITY_API_READ_TOKEN: z.string().min(1),
    // resend
    RESEND_API_KEY: z.string().min(1),
    // klaviyo
    KLAVIYO_PRIVATE_API_KEY: z.string().min(1),
    // algolia
    ALGOLIA_API_KEY: z.string().min(1),
  },
  runtimeEnv: {
    NEXT_PUBLIC_GOOGLE_MAPS_API_KEY:
      process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY,
    NEXT_PUBLIC_API_ROOT_URL: process.env.NEXT_PUBLIC_API_ROOT_URL,
    DATABASE_URL: process.env.DATABASE_URL,
    DIRECT_URL: process.env.DIRECT_URL,
    GITHUB_ID: process.env.GITHUB_ID,
    GITHUB_SECRET: process.env.GITHUB_SECRET,
    GOOGLE_CLIENT_ID: process.env.GOOGLE_CLIENT_ID,
    GOOGLE_CLIENT_SECRET: process.env.GOOGLE_CLIENT_SECRET,
    NEXT_PUBLIC_MAPBOX_TOKEN: process.env.NEXT_PUBLIC_MAPBOX_TOKEN,
    // Slack
    SLACK_ACCESS_TOKEN: process.env.SLACK_ACCESS_TOKEN,
    SLACK_CUSTOMER_CHANNEL_ID: process.env.SLACK_CUSTOMER_CHANNEL_ID,
    SLACK_TEAM_VERIFICATION_CHANNEL_ID:
      process.env.SLACK_TEAM_VERIFICATION_CHANNEL_ID,
    SLACK_AD_CONTACT_CHANNEL_ID: process.env.SLACK_AD_CONTACT_CHANNEL_ID,
    SLACK_USER_SIGNUP_CHANNEL_ID: process.env.SLACK_USER_SIGNUP_CHANNEL_ID,
    SLACK_STATS_CHANNEL_ID: process.env.SLACK_STATS_CHANNEL_ID,
    SLACK_MAILING_LIST_CHANNEL_ID: process.env.SLACK_MAILING_LIST_CHANNEL_ID,
    SLACK_SANITY_UPDATES_CHANNEL_ID:
      process.env.SLACK_SANITY_UPDATES_CHANNEL_ID,
    SLACK_USER_TEAM_INTEREST_CHANNEL_ID:
      process.env.SLACK_USER_TEAM_INTEREST_CHANNEL_ID,
    // Sanity CMS
    NEXT_PUBLIC_SANITY_PROJECT_ID: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID,
    SANITY_API_READ_TOKEN: process.env.SANITY_API_READ_TOKEN,
    // Resend - emails
    RESEND_API_KEY: process.env.RESEND_API_KEY,
    // supabase
    NEXT_PUBLIC_SUPABASE_URL: process.env.NEXT_PUBLIC_SUPABASE_URL,
    NEXT_PUBLIC_SUPABASE_ANON_KEY: process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY,
    // Klaviyo
    KLAVIYO_PRIVATE_API_KEY: process.env.KLAVIYO_PRIVATE_API_KEY,
    NEXT_PUBLIC_KLAVIYO_PUBLIC_API_KEY:
      process.env.NEXT_PUBLIC_KLAVIYO_PUBLIC_API_KEY,
    // posthog
    NEXT_PUBLIC_POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY,
    NEXT_PUBLIC_POSTHOG_HOST: process.env.NEXT_PUBLIC_POSTHOG_HOST,
    // algolia
    ALGOLIA_API_KEY: process.env.ALGOLIA_API_KEY,
    NEXT_PUBLIC_ALGOLIA_APP_ID: process.env.NEXT_PUBLIC_ALGOLIA_APP_ID,
    NEXT_PUBLIC_SEARCH_ALGOLIA_API_KEY:
      process.env.NEXT_PUBLIC_SEARCH_ALGOLIA_API_KEY,
  },
});
